export const formatNumber = value => {
  const locale = document.documentElement.lang;
  return value.toLocaleString(locale);
};



// WEBPACK FOOTER //
// ./app/javascript/lib/number.js